/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-09-13
 * Copyright All Rights Reserved
 */
import config from 'src/js/support/config';
import { getToken, getUser } from 'selectors/tokenSelectors';
import {
  REQUEST_FETCH_REPORTS,
  REQUEST_FETCH_REPORTS_SUCCESS,
  REQUEST_FETCH_REPORTS_FAILURE,
} from 'constants/actionTypes';

import apiBaseUrl from 'support/apiBaseUrl';

const axios = require('axios');

export const fetchReports = () => (dispatch, getState) => {
  const state = getState();
  const token = getToken(state);
  const userId = getUser(state);
  dispatch({ type: REQUEST_FETCH_REPORTS });
  const options = {
    url: `${apiBaseUrl(config)}/users/${userId}/reports/company`,
    headers: {
      Authorization: `bearer ${token}`,
      'Content-Type': 'application/json',
    },
    method: 'get',
  };
  return axios(options)
    .then((response) => {
      dispatch({ type: REQUEST_FETCH_REPORTS_SUCCESS, data: response.data });
    }).catch((error) => {
      dispatch({ type: REQUEST_FETCH_REPORTS_FAILURE, error });
    });
};
